/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const listContentTypesResponseDataContentTypesNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const listContentTypesResponseDataContentTypesNodesItemTypeDefinitionReferenceViewPredicatesMax = 10;

export const listContentTypesResponseDataContentTypesNodesItemTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const listContentTypesResponseDataContentTypesNodesItemTypeDefinitionReferenceViewSearchTermsMax = 10;

export const ListContentTypesResponse = zod.object({
  data: zod.object({
    contentTypes: zod.object({
      nodes: zod.array(
        zod.object({
          description: zod.string().nullable(),
          fieldCount: zod.int(),
          name: zod.string(),
          parentTypeName: zod.string().nullable(),
          parentTypeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          typeDefinition: zod
            .object({
              conformance: zod.enum(['open', 'lax', 'strict']).optional(),
              description: zod.string().nullish(),
              enums: zod
                .array(
                  zod.object({
                    label: zod.string(),
                    value: zod.string(),
                  }),
                )
                .nullish(),
              file: zod
                .object({
                  allowedFormats: zod
                    .array(
                      zod.enum([
                        'pdf',
                        'doc',
                        'docx',
                        'xls',
                        'xlsx',
                        'csv',
                        'txt',
                        'jpeg',
                        'png',
                        'webp',
                        'gif',
                        'heic',
                        'md',
                        'html',
                        'mp3',
                        'm4a',
                        'wav',
                        'mp4',
                        'mov',
                        'webm',
                      ]),
                    )
                    .min(1)
                    .optional(),
                })
                .nullish(),
              metadata: zod.record(zod.string(), zod.unknown()).nullish(),
              reference: zod
                .object({
                  carbonCopy: zod.boolean().optional(),
                  creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
                  edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
                  typeLineageUuid: zod.uuid(),
                  typeUuid: zod.uuid(),
                  view: zod
                    .object({
                      predicates: zod
                        .array(
                          zod.object({
                            op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                            pathTypeUuids: zod
                              .array(zod.uuid())
                              .min(1)
                              .max(
                                listContentTypesResponseDataContentTypesNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax,
                              ),
                            value: zod.string().optional(),
                            valueType: zod
                              .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                              .optional(),
                          }),
                        )
                        .max(
                          listContentTypesResponseDataContentTypesNodesItemTypeDefinitionReferenceViewPredicatesMax,
                        )
                        .optional(),
                      searchTerms: zod
                        .array(
                          zod
                            .string()
                            .min(1)
                            .max(
                              listContentTypesResponseDataContentTypesNodesItemTypeDefinitionReferenceViewSearchTermsItemMax,
                            ),
                        )
                        .max(
                          listContentTypesResponseDataContentTypesNodesItemTypeDefinitionReferenceViewSearchTermsMax,
                        )
                        .optional(),
                    })
                    .nullish(),
                })
                .nullish(),
              signature: zod.looseObject({}).nullish(),
            })
            .nullish()
            .describe(
              'Stored TYPE configuration: description, arbitrary metadata, ENUM value\/label pairs, and the reference \/ file \/ signature field bags.',
            ),
          uuid: zod.uuid().describe('UUID v4 identifier'),
          valueType: zod.string().nullable(),
        }),
      ),
      totalCount: zod.int(),
    }),
  }),
});

export type ListContentTypesResponse = zod.input<typeof ListContentTypesResponse>;
export type ListContentTypesResponseOutput = zod.output<typeof ListContentTypesResponse>;
